import { Component, OnDestroy, OnInit } from '@angular/core';
import { CardCircularChartComponent } from '../../components/card-circular-chart/card-circular-chart.component';
import { CardBarlineChartComponent } from '../../components/card-barline-chart/card-barline-chart.component';
import { CardValuePairComponent } from '../../components/card-value-pair/card-value-pair.component';
import { CentroGestion } from '../../models/centro_gestion';
import { forkJoin, Subscription } from 'rxjs';
import { Proveedor } from '../../models/proveedor';
import { OrdenCompraService } from '../../services/api/orden-compra.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import {
  ID_PERIODO_ANO_ANTERIOR,
  ID_PERIODO_ULTIMOS_SEIS_MESES,
  PERIODOS,
} from '../../constants/list';
import { TotalesOC } from '../../models/totales_oc';
import { Periodo } from '../../models/periodo';
import {
  getDateRangeFromMonths,
  getDateRangeFromPreviousYear,
} from '../../utils/period';
import { format, formatToMM } from '../../utils/number';
import {
  CardRankingComponent,
  Ranking,
} from '../../components/card-ranking/card-ranking.component';
import { Select } from 'primeng/select';
import { CardDoughnutChartComponent } from '../../components/card-doughnut-chart/card-doughnut-chart.component';
import { CardBarChartComponent } from '../../components/card-bar-chart/card-bar-chart.component';
import { EmpresaService } from '../../services/empresa.service';

@Component({
  selector: 'app-dashboard-cot',
  imports: [
    FormsModule,
    CommonModule,
    CardCircularChartComponent,
    CardBarChartComponent,
    CardBarlineChartComponent,
    CardValuePairComponent,
    CardRankingComponent,
    Select,
    CardDoughnutChartComponent,
  ],
  templateUrl: './dashboard-oc.component.html',
  styleUrl: './dashboard-oc.component.css',
  standalone: true,
})
export class DashboardOcComponent implements OnInit, OnDestroy {
  periodos: Periodo[] = [];
  centrosGestion: CentroGestion[] = [];
  proveedores: Proveedor[] = [];
  totalesOC: TotalesOC | null = null;
  rankingProveedores: Ranking[] = [];

  selectedPeriodo: number = ID_PERIODO_ULTIMOS_SEIS_MESES;
  selectedCentroGestion: number = 0;
  selectedProveedor: number = 0;

  formattedMontoOCTotales = '';
  formattedCantidadOCTotales = '';
  formattedMontoOCTotalesRecibir = '';
  porcentajeTotalesRecibir: number = 0;
  formattedCantidadProveedores = '';
  porcentajeProveedores: number = 0;
  labelsEvolucionOC: string[] = [];
  cantidadeOCEvolucionOC: number[] = [];
  montoOCEvolucionOC: number[] = [];
  montoPorRecibirEvolucionOC: number[] = [];
  formattedCantidadTipoCompra = '';
  formattedMontoTipoCompra = '';
  formattedMontoPromedioTipoCompra = '';
  dataTipoCompra: number[] = [];
  formattedCentrosGestionCentroOC = '';
  formattedUsuarioCentroOC = '';
  formattedCantidadOCConvenio = '';
  formattedMontoOCConvenio = '';
  formattedCantidadOCMenorQue = '';
  formattedMontoOCMenorQue = '';
  formattedCantidadOCMayorQue = '';
  formattedMontoOCMayorQue = '';
  labelsCentroOCMonthly: string[] = [];
  usuariosCentroOCMonthly: number[] = [];
  labelsOCConvenioMonthly: string[] = [];
  cantidadOCConvenioMonthly: number[] = [];
  labelsOCMenorQueMonthly: string[] = [];
  cantidadOCMenorQueMonthly: number[] = [];
  labelsOCMayorQueMonthly: string[] = [];
  cantidadOCMayorQueMonthly: number[] = [];

  colors: string[] = [
    '#FF6B00',
    '#f18b38',
    '#e35903',
    '#e35903',
    '#d38d3a',
    '#ffbc6c',
    '#f98e24',
  ];

  isLoadingTotalesOC: boolean = false;
  isLoadingTotalesRecibir: boolean = false;
  isLoadingCantidadProveedores: boolean = false;
  isLoadingEvolucionOC: boolean = false;
  isLoadingRankingProveedores: boolean = false;
  isLoadingTipoCompra: boolean = false;
  isLoadingCentroOC: boolean = false;
  isLoadingOCConvenio: boolean = false;
  isLoadingOCMenorQue: boolean = false;
  isLoadingOCMayorQue: boolean = false;
  isLoadingCentroOCMonthly: boolean = false;
  isLoadingOCConvenioMonthly: boolean = false;
  isLoadingOCMenorQueMonthly: boolean = false;
  isLoadingOCMayorQueMonthly: boolean = false;

  private dataSub: Subscription | null = null;
  private totalesOCSub: Subscription | null = null;
  private totalesRecibirSub: Subscription | null = null;
  private cantidadProveedoresSub: Subscription | null = null;
  private evolucionOCSub: Subscription | null = null;
  private rankingProveedoresSub: Subscription | null = null;
  private tipoCompraSub: Subscription | null = null;
  private centroGestionSub: Subscription | null = null;
  private ocConveioSub: Subscription | null = null;
  private ocMenorQueSub: Subscription | null = null;
  private ocMayorQueSub: Subscription | null = null;
  private centroGestionMonthlySub: Subscription | null = null;
  private ocConveioMonthlySub: Subscription | null = null;
  private ocMenorQueMonthlySub: Subscription | null = null;
  private ocMayorQueMonthlySub: Subscription | null = null;

  constructor(
    private ordenCompraService: OrdenCompraService,
    private empresaService: EmpresaService
  ) {}

  ngOnInit() {
    this.periodos = PERIODOS;

    this.isLoadingTotalesOC = true;
    this.isLoadingTotalesRecibir = true;
    this.isLoadingCantidadProveedores = true;
    this.isLoadingEvolucionOC = true;
    this.isLoadingRankingProveedores = true;
    this.isLoadingTipoCompra = true;
    this.isLoadingOCMayorQue = true;
    this.isLoadingCentroOC = true;
    this.isLoadingOCConvenio = true;
    this.isLoadingOCMenorQue = true;
    this.isLoadingCentroOCMonthly = true;
    this.isLoadingOCConvenioMonthly = true;
    this.isLoadingOCMenorQueMonthly = true;
    this.isLoadingOCMayorQueMonthly = true;

    this.dataSub = forkJoin({
      centrosGestion: this.ordenCompraService.getCentrosGestion(),
      proveedores: this.ordenCompraService.getProveedores(),
    }).subscribe({
      next: (data) => {
        let sortedCentrosGestion = data.centrosGestion.sort((a, b) =>
          a.nombre_orgc.localeCompare(b.nombre_orgc)
        );

        let sortedProveedores = data.proveedores.sort((a, b) =>
          a.nombre_empresa.localeCompare(b.nombre_empresa)
        );

        this.centrosGestion = sortedCentrosGestion;
        this.proveedores = sortedProveedores;

        this.loadAllCards();
      },
      error: (err) => {
        console.log('🚀 ~ DashboardOcComponent ~ ngOnInit ~ err:', err);
        this.isLoadingTotalesOC = false;
        this.isLoadingCantidadProveedores = false;
        this.isLoadingEvolucionOC = false;
        this.isLoadingRankingProveedores = false;
        this.isLoadingTipoCompra = false;
        this.isLoadingCentroOC = false;
        this.isLoadingOCMayorQue = false;
        this.isLoadingOCConvenio = false;
        this.isLoadingOCMenorQue = false;
        this.isLoadingCentroOCMonthly = false;
        this.isLoadingOCConvenioMonthly = false;
        this.isLoadingOCMenorQueMonthly = false;
        this.isLoadingOCMayorQueMonthly = false;

      },
    });
  }

  ngOnDestroy() {
    if (this.dataSub) {
      this.dataSub.unsubscribe();
    }

    if (this.totalesOCSub) {
      this.totalesOCSub.unsubscribe();
    }

    if (this.totalesRecibirSub) {
      this.totalesRecibirSub.unsubscribe();
    }

    if (this.cantidadProveedoresSub) {
      this.cantidadProveedoresSub.unsubscribe();
    }

    if (this.evolucionOCSub) {
      this.evolucionOCSub.unsubscribe();
    }

    if (this.rankingProveedoresSub) {
      this.rankingProveedoresSub.unsubscribe();
    }

    if (this.tipoCompraSub) {
      this.tipoCompraSub.unsubscribe();
    }

    if (this.centroGestionSub) {
      this.centroGestionSub.unsubscribe();
    }

    if (this.ocConveioSub) {
      this.ocConveioSub.unsubscribe();
    }

    if (this.ocMenorQueSub) {
      this.ocMenorQueSub.unsubscribe();
    }

    if (this.ocMayorQueSub) {
      this.ocMayorQueSub.unsubscribe();
    }

    if (this.centroGestionMonthlySub) {
      this.centroGestionMonthlySub.unsubscribe();
    }

    if (this.ocConveioMonthlySub) {
      this.ocConveioMonthlySub.unsubscribe();
    }

    if (this.ocMenorQueMonthlySub) {
      this.ocMenorQueMonthlySub.unsubscribe();
    }

    if (this.ocMayorQueMonthlySub) {
      this.ocMayorQueMonthlySub.unsubscribe();
    }
  }

  loadAllCards() {
    this.fetchTotalesOC();
    this.fetchCantidadProveedores();
    this.fetchEvolucionOC();
    this.fetchRankingProveedores();
    this.fetchTipoCompra();
    this.fetchCentroOC();
    this.fetchOCConvenio();
    this.fetchOCMenorQue();
    this.fetchOCMayorQue();
    this.fetchCentroOCMonthly();
    this.fetchOCConvenioMonthly();
    this.fetchOCMenorQueMonthly();
    this.fetchOCMayorQueMonthly();
  }

  fetchTotalesOC() {
    let fechaInicio = 0;
    let fechaFin = 0;

    // Obtiene el rango de fechas
    ({ startDate: fechaInicio, endDate: fechaFin } = this.getDateRange());
    this.isLoadingTotalesOC = true;
    this.totalesOCSub = this.ordenCompraService
      .getTotalesOC(
        fechaInicio,
        fechaFin,
        this.selectedCentroGestion,
        this.selectedProveedor
      )
      .subscribe({
        next: (data) => {
          this.totalesOC = data;

          this.formattedMontoOCTotales = `${formatToMM(data.monto_oc, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}MM`;
          this.formattedCantidadOCTotales = `#${format(data.cantidad_oc)}`;

          this.fetchTotalesRecibir(data.monto_oc);
        },
        error(err) {
          console.log('🚀 ~ DashboardOcComponent ~ error ~ err:', err);
        },
        complete: () => {
          this.isLoadingTotalesOC = false;
        },
      });
  }

  fetchTotalesRecibir(montoTotalesOC: number) {
    let fechaInicio = 0;
    let fechaFin = 0;

    // Obtiene el rango de fechas
    ({ startDate: fechaInicio, endDate: fechaFin } = this.getDateRange());
    this.isLoadingTotalesRecibir = true;
    this.totalesRecibirSub = this.ordenCompraService
      .getTotalesPorRecibir(
        fechaInicio,
        fechaFin,
        this.selectedCentroGestion,
        this.selectedProveedor
      )
      .subscribe({
        next: (data) => {
          this.formattedMontoOCTotalesRecibir = `${formatToMM(data.monto_oc, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}MM`;

          let percentage =
            montoTotalesOC > 0 ? (data.monto_oc / montoTotalesOC) * 100 : 0;
          percentage = Math.round(percentage);

          this.porcentajeTotalesRecibir = percentage;
        },
        error(err) {
          console.log('🚀 ~ DashboardOcComponent ~ error ~ err:', err);
        },
        complete: () => {
          this.isLoadingTotalesRecibir = false;
        },
      });
  }

  fetchCantidadProveedores() {
    let fechaInicio = 0;
    let fechaFin = 0;

    // Obtiene el rango de fechas
    ({ startDate: fechaInicio, endDate: fechaFin } = this.getDateRange());
    this.isLoadingCantidadProveedores = true;
    this.cantidadProveedoresSub = this.ordenCompraService
      .getCantidadProveedores(
        fechaInicio,
        fechaFin,
        this.selectedCentroGestion,
        this.selectedProveedor
      )
      .subscribe({
        next: (data) => {
          this.formattedCantidadProveedores = `${format(data.proveedores)}`;

          // Calcula porcentaje del gráfico
          let count = this.proveedores.length;
          let percentage = 0;

          if (this.proveedores.length > 0) {
            percentage = (data.proveedores / this.proveedores.length) * 100;
            percentage = Math.round(percentage);
          }

          this.porcentajeProveedores = percentage;
        },
        error(err) {
          console.log('🚀 ~ DashboardOcComponent ~ error ~ err:', err);
        },
        complete: () => {
          this.isLoadingCantidadProveedores = false;
        },
      });
  }

  fetchEvolucionOC() {
    let fechaInicio = 0;
    let fechaFin = 0;

    // Obtiene el rango de fechas
    ({ startDate: fechaInicio, endDate: fechaFin } = this.getDateRange());
    this.isLoadingEvolucionOC = true;
    this.evolucionOCSub = this.ordenCompraService
      .getEvolucionOc(
        fechaInicio,
        fechaFin,
        this.selectedCentroGestion,
        this.selectedProveedor
      )
      .subscribe({
        next: (data) => {
          this.labelsEvolucionOC = [];
          this.cantidadeOCEvolucionOC = [];
          this.montoOCEvolucionOC = [];
          this.montoPorRecibirEvolucionOC = [];

          data.map((item) => {
            this.labelsEvolucionOC.push(
              `${item.nombre_mes_corto} ${item.year}`
            );
            this.cantidadeOCEvolucionOC.push(item.cantidad_oc);
            this.montoOCEvolucionOC.push(item.monto_oc);
            this.montoPorRecibirEvolucionOC.push(item.monto_por_recibir);
          });
        },
        error(err) {
          console.log('🚀 ~ DashboardOcComponent ~ error ~ err:', err);
        },
        complete: () => {
          this.isLoadingEvolucionOC = false;
        },
      });
  }

  fetchRankingProveedores() {
    let fechaInicio = 0;
    let fechaFin = 0;

    // Obtiene el rango de fechas
    ({ startDate: fechaInicio, endDate: fechaFin } = this.getDateRange());
    this.isLoadingRankingProveedores = true;
    this.rankingProveedoresSub = this.ordenCompraService
      .getRankinProveedores(
        fechaInicio,
        fechaFin,
        this.selectedCentroGestion,
        this.selectedProveedor
      )
      .subscribe({
        next: (data) => {
          const firstSixItems = data.slice(0, 6);
          const restOfTheItems = data.slice(6);

          // Obtiene el proveedor con mayor monto (dentro de los primeros 6)
          const maxItem = firstSixItems.reduce((max, current) => {
            return current.monto > max.monto ? current : max;
          }, firstSixItems[0]);

          // Suma el monto del resto de proveedores (desde el 7 en adelante)
          const sumRestMontos = restOfTheItems.reduce(
            (sum, item) => sum + item.monto,
            0
          );
          const devider =
            maxItem?.monto > sumRestMontos ? maxItem?.monto : sumRestMontos;

          const rankings: Ranking[] = firstSixItems.map((item) => {
            const percentage =
              devider === 0 ? 0 : Math.round((item.monto / devider) * 100);
            return {
              label: item.nombre_empresa,
              value: `${formatToMM(item.monto, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}MM`,
              percentage,
            };
          });

          // Agrega el ítem otros
          const percentageOtros = Math.round(sumRestMontos / devider) * 100;
          this.rankingProveedores = [
            ...rankings,
            {
              label: 'Otros',
              value: `${formatToMM(sumRestMontos, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}MM`,
              percentage: percentageOtros,
            },
          ];
        },
        error(err) {
          console.log('🚀 ~ DashboardOcComponent ~ error ~ err:', err);
        },
        complete: () => {
          this.isLoadingRankingProveedores = false;
        },
      });
  }

  fetchTipoCompra() {
    let fechaInicio = 0;
    let fechaFin = 0;

    // Obtiene el rango de fechas
    ({ startDate: fechaInicio, endDate: fechaFin } = this.getDateRange());
    this.isLoadingTipoCompra = true;
    this.tipoCompraSub = this.ordenCompraService
      .getTipoCompra(
        fechaInicio,
        fechaFin,
        this.selectedCentroGestion,
        this.selectedProveedor
      )
      .subscribe({
        next: (data) => {
          const directa = data.monto - data.convenio - data.cotizacion;
          this.dataTipoCompra = [data.cotizacion, data.convenio, directa];

          this.formattedCantidadTipoCompra = `#${format(data.cantidad)}`;

          this.formattedMontoTipoCompra = `$ ${formatToMM(data.monto, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}MM`;

          let montoPromedio =
            data.cantidad > 0 ? data.monto / data.cantidad : 0;
          this.formattedMontoPromedioTipoCompra = `$ ${formatToMM(
            montoPromedio,
            {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }
          )}MM`;
        },
        error(err) {
          console.log('🚀 ~ DashboardOcComponent ~ error ~ err:', err);
        },
        complete: () => {
          this.isLoadingTipoCompra = false;
        },
      });
  }

  fetchCentroOC() {
    let fechaInicio = 0;
    let fechaFin = 0;

    // Obtiene el rango de fechas
    ({ startDate: fechaInicio, endDate: fechaFin } = this.getDateRange());
    this.isLoadingCentroOC = true;
    this.centroGestionSub = this.ordenCompraService
      .getCentroOC(
        fechaInicio,
        fechaFin,
        this.selectedCentroGestion,
        this.selectedProveedor
      )
      .subscribe({
        next: (data) => {
          this.formattedCentrosGestionCentroOC = `${format(
            data.centros_gestion
          )}`;
          this.formattedUsuarioCentroOC = `${format(data.usuarios)}`;
        },
        error(err) {
          console.log('🚀 ~ DashboardOcComponent ~ error ~ err:', err);
        },
        complete: () => {
          this.isLoadingCentroOC = false;
        },
      });
  }

  fetchOCConvenio() {
    let fechaInicio = 0;
    let fechaFin = 0;

    // Obtiene el rango de fechas
    ({ startDate: fechaInicio, endDate: fechaFin } = this.getDateRange());
    this.isLoadingOCConvenio = true;
    this.ocConveioSub = this.ordenCompraService
      .getOCConvenio(
        fechaInicio,
        fechaFin,
        this.selectedCentroGestion,
        this.selectedProveedor
      )
      .subscribe({
        next: (data) => {
          this.formattedCantidadOCConvenio = `${format(data.cantidad_oc)}`;
          this.formattedMontoOCConvenio = `$ ${formatToMM(data.monto_oc, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}MM`;
        },
        error(err) {
          console.log('🚀 ~ DashboardOcComponent ~ error ~ err:', err);
        },
        complete: () => {
          this.isLoadingOCConvenio = false;
        },
      });
  }

  fetchOCMenorQue() {
    let fechaInicio = 0;
    let fechaFin = 0;

    // Obtiene el rango de fechas
    ({ startDate: fechaInicio, endDate: fechaFin } = this.getDateRange());
    this.isLoadingOCMenorQue = true;
    this.ocMenorQueSub = this.ordenCompraService
      .getOCMenorQue(
        fechaInicio,
        fechaFin,
        this.selectedCentroGestion,
        this.selectedProveedor
      )
      .subscribe({
        next: (data) => {
          this.formattedCantidadOCMenorQue = `${format(data.cantidad_oc)}`;
          this.formattedMontoOCMenorQue = `$ ${formatToMM(data.monto_oc, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}MM`;
        },
        error(err) {
          console.log('🚀 ~ DashboardOcComponent ~ error ~ err:', err);
        },
        complete: () => {
          this.isLoadingOCMenorQue = false;
        },
      });
  }

  fetchOCMayorQue() {
    let fechaInicio = 0;
    let fechaFin = 0;

    // Obtiene el rango de fechas
    ({ startDate: fechaInicio, endDate: fechaFin } = this.getDateRange());
    this.isLoadingOCMayorQue = true;
    this.ocMayorQueSub = this.ordenCompraService
      .getOCMayoresQue(
        fechaInicio,
        fechaFin,
        this.selectedCentroGestion,
        this.selectedProveedor
      )
      .subscribe({
        next: (data) => {
          this.formattedCantidadOCMayorQue = `${format(data.cantidad_oc)}`;
          this.formattedMontoOCMayorQue = `$ ${formatToMM(data.monto_oc, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}MM`;
        },
        error(err) {
          console.log('🚀 ~ DashboardOcComponent ~ error ~ err:', err);
        },
        complete: () => {
          this.isLoadingOCMayorQue = false;
        },
      });
  }

  fetchCentroOCMonthly() {
    let fechaInicio = 0;
    let fechaFin = 0;

    // Obtiene el rango de fechas
    ({ startDate: fechaInicio, endDate: fechaFin } = this.getDateRange());
    this.isLoadingCentroOCMonthly = true;
    this.centroGestionMonthlySub = this.ordenCompraService
      .getCentroOCMonthly(
        fechaInicio,
        fechaFin,
        this.selectedCentroGestion,
        this.selectedProveedor
      )
      .subscribe({
        next: (data) => {
          this.labelsCentroOCMonthly = [];
          this.usuariosCentroOCMonthly = [];

          data.map((item) => {
            this.labelsCentroOCMonthly.push(
              `${item.nombre_mes_corto} ${item.year}`
            );
            this.usuariosCentroOCMonthly.push(item.usuarios);
          });
        },
        error(err) {
          console.log('🚀 ~ DashboardOcComponent ~ error ~ err:', err);
        },
        complete: () => {
          this.isLoadingCentroOCMonthly = false;
        },
      });
  }

  fetchOCConvenioMonthly() {
    let fechaInicio = 0;
    let fechaFin = 0;

    // Obtiene el rango de fechas
    ({ startDate: fechaInicio, endDate: fechaFin } = this.getDateRange());
    this.isLoadingOCConvenioMonthly = true;
    this.ocConveioMonthlySub = this.ordenCompraService
      .getOCConvenioMonthly(
        fechaInicio,
        fechaFin,
        this.selectedCentroGestion,
        this.selectedProveedor
      )
      .subscribe({
        next: (data) => {
          this.labelsOCConvenioMonthly = [];
          this.cantidadOCConvenioMonthly = [];

          data.map((item) => {
            this.labelsOCConvenioMonthly.push(
              `${item.nombre_mes_corto} ${item.year}`
            );
            this.cantidadOCConvenioMonthly.push(item.cantidad_oc);
          });
        },
        error(err) {
          console.log('🚀 ~ DashboardOcComponent ~ error ~ err:', err);
        },
        complete: () => {
          this.isLoadingOCConvenioMonthly = false;
        },
      });
  }

  fetchOCMenorQueMonthly() {
    let fechaInicio = 0;
    let fechaFin = 0;

    // Obtiene el rango de fechas
    ({ startDate: fechaInicio, endDate: fechaFin } = this.getDateRange());
    this.isLoadingOCMenorQueMonthly = true;
    this.ocMenorQueMonthlySub = this.ordenCompraService
      .getOCMenorQueMonthly(
        fechaInicio,
        fechaFin,
        this.selectedCentroGestion,
        this.selectedProveedor
      )
      .subscribe({
        next: (data) => {
          this.labelsOCMenorQueMonthly = [];
          this.cantidadOCMenorQueMonthly = [];

          data.map((item) => {
            this.labelsOCMenorQueMonthly.push(
              `${item.nombre_mes_corto} ${item.year}`
            );
            this.cantidadOCMenorQueMonthly.push(item.cantidad_oc);
          });
        },
        error(err) {
          console.log('🚀 ~ DashboardOcComponent ~ error ~ err:', err);
        },
        complete: () => {
          this.isLoadingOCMenorQueMonthly = false;
        },
      });
  }

  fetchOCMayorQueMonthly() {
    let fechaInicio = 0;
    let fechaFin = 0;

    // Obtiene el rango de fechas
    ({ startDate: fechaInicio, endDate: fechaFin } = this.getDateRange());
    this.isLoadingOCMayorQueMonthly = true;
    this.ocMayorQueMonthlySub = this.ordenCompraService
      .getOCMayoresQueMonthly(
        fechaInicio,
        fechaFin,
        this.selectedCentroGestion,
        this.selectedProveedor
      )
      .subscribe({
        next: (data) => {
          this.labelsOCMayorQueMonthly = [];
          this.cantidadOCMayorQueMonthly = [];

          data.map((item) => {
            this.labelsOCMayorQueMonthly.push(
              `${item.nombre_mes_corto} ${item.year}`
            );
            this.cantidadOCMayorQueMonthly.push(item.cantidad_oc);
          });
        },
        error(err) {
          console.log('🚀 ~ DashboardOcComponent ~ error ~ err:', err);
        },
        complete: () => {
          this.isLoadingOCMayorQueMonthly = false;
        },
      });
  }

  onPeriodoChange() {
    this.loadAllCards();
  }

  onCentroGestionChange() {
    this.loadAllCards();
  }

  onProveedorChange() {
    this.loadAllCards();
  }

  getDateRange = (): {
    startDate: number;
    endDate: number;
  } => {
    let startDate = 0;
    let endDate = 0;

    switch (+this.selectedPeriodo) {
      case ID_PERIODO_ULTIMOS_SEIS_MESES:
        ({ startDate, endDate } = getDateRangeFromMonths(6));

        break;
      case ID_PERIODO_ANO_ANTERIOR:
        ({ startDate, endDate } = getDateRangeFromPreviousYear());

        break;
      default:
        break;
    }

    return {
      startDate,
      endDate,
    };
  };
  downloadReporteOc() {
    let fechaInicio = 0;
    let fechaFin = 0;
    ({ startDate: fechaInicio, endDate: fechaFin } = this.getDateRange());

    this.ordenCompraService
      .getReporteOc(fechaInicio, fechaFin, this.selectedCentroGestion, this.selectedProveedor)
      .subscribe({
        next: (response) => {
          const blob = new Blob([response], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'reporte_oc.xlsx'; // Nombre del archivo
          document.body.appendChild(a); // Asegura que el elemento esté en el DOM
          a.click();
          document.body.removeChild(a); // Limpia el DOM después de la descarga
          window.URL.revokeObjectURL(url); // Libera el objeto URL
        },
        error: (err) => {
          console.error('Error al descargar el reporte:', err);
        },
        complete: () => {
          console.log('Descarga completada.');
        },
      });
  }
}
